export const PASSWORD_ERR_MSG = {
  REQIRED: "Please enter your password",
  MIN_LENGTH: "Password is too short - it must contain at least 8 characters",
  LOWER_CASE_REQ:
    "Password is too weak - it must contain at least 1 lower case character",
  NUMBER_REQ: "Password is too weak - it must contain at least 1 number",
  UPPER_CASE_REQ:
    "Password is too weak - it must contain at least 1 upper case character",
  SPECIAL_CHAR_REQ:
    "Password is too weak - it must contain at least 1 special character",
};

export const CONFIRM_PASSWORD_ERROR_MSG = {
  REQUIRED: "Please confirm your password",
  NOT_MATCH: "Password does not match",
};

// export const SERVER_ERR_MSG = "Server gặp sự cố, vui lòng thử lại sau";
